import { Input, InputProps } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";

import { RegisterOptions } from "react-hook-form";
import { BaseFormControl } from "./abstractions/base-form-control";
import { useCustomFormats } from "hooks/useCustomFormat";

type FormInputProps = InputProps & {
  name: string;
  label: string;
  placeholder?: string;
  rules?: RegisterOptions;
  type: "text" | "number" | "email" | "date" | "time" | "datetime-local" | "tel" | "textarea";
  isReadOnly?: boolean;
};

export function FormInput({
  name,
  label,
  placeholder,
  rules,
  type,
  isReadOnly,
  ...props
}: FormInputProps) {
  const { register } = useFormContext();

  const { dateFormat } = useCustomFormats();

  const getPlaceholder = () => {
    if (placeholder) return placeholder;

    if (type === "date") return dateFormat;
    if (type === "time") return "HH:MM";
    if (type === "datetime-local") return `${dateFormat} HH:MM`;
    if (type === "number") return "0";
    if (type === "tel") return "(400) 000-0000";

    return label;
  };

  return (
    <BaseFormControl
      name={name}
      label={label}
      isRequired={!!rules?.required}
      isDisabled={!!rules?.disabled}
      isReadOnly={isReadOnly}
    >
      <Input
        variant="primary"
        placeholder={getPlaceholder()}
        type={type}
        {...register(name, rules)}
        {...props}
      />
    </BaseFormControl>
  );
}
